import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { inIframe } from '@chilecompra/react-kit/utils'
import { Body, Featured, Header, Root, Section, Footer, BaseContainer } from './BrandLayout.styles'

/**
 * The BrandLayout's component.
 */
const BrandLayout = props => {
  const { children, featured, header, footer } = props

  const isInIframe = useMemo(() => {
    return inIframe()
  }, [])

  return (
    <Root inIframe={isInIframe}>
      <BaseContainer>
        {header && <Header>{header}</Header>}
        {featured && <Featured>{featured}</Featured>}
        <Body container>
          <Section item md={12} sm={12} xs={12}>
            {children}
          </Section>
        </Body>
      </BaseContainer>
      {footer && <Footer>{footer}</Footer>}
    </Root>
  )
}

BrandLayout.propTypes = {
  children: PropTypes.node.isRequired,
  featured: PropTypes.node,
  header: PropTypes.node,
  footer: PropTypes.node
}

export default BrandLayout
